import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4babe0ea&scoped=true&"
import script from "./App.vue?vue&type=script&lang=ts&"
export * from "./App.vue?vue&type=script&lang=ts&"
import style0 from "assets/css/common/landscape.css?vue&type=style&index=0&id=4babe0ea&scoped=true&lang=css&"
import style1 from "@tencent/tigui/scss/reset/reset_m.scss?vue&type=style&index=1&lang=scss&"
import style2 from "assets/scss/client-dev/2020/index.scss?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4babe0ea",
  null
  
)

export default component.exports